/**
 * React CSSProperties doesn't add typing for custom properties out of the box,
 * we augment it here to ensure that this is fully supported
 */

/**
 * low-level utility designed to be used in other token maker functions to
 * abstract boiler-platey code
 *
 * this method is NOT intended to be used for the actual creation of tokens,
 * if you're looking to do so, please refer to one of the specific
 * implementations (e.g. makeColorToken or makeFontToken)
 */
function makeGenericToken(formatter, override, extend, tokenProps) {
  const token = Object.assign((...args) => formatter(...args), {
    ...tokenProps,
    __extend: propName => {
      return extend(propName, token);
    },
    __override: nextValue => {
      const output = override(nextValue);

      // define a toString() method, which will translate the CSS property
      // record into a valid CSS string that can be interpolated into e.g.
      // linaria
      Object.defineProperty(output, "toString", {
        enumerable: false,
        value: options => {
          const css = Object.entries(output).flatMap(([key, value]) => `${key}:${value}${options?.priority ? ` ${options.priority}` : ""}`).join(";");
          return css ? `${css};` : "";
        }
      });
      return output;
    }
  });
  return token;
}

export { makeGenericToken };
//# sourceMappingURL=util.make-generic-token.js.map
